import React from 'react';
import AdCaller from 'helpers/ads/adCaller';
import Link from 'components/Link';
import s from './ResultStateWidget.scss';
// import AlliancePopup from '../../common/AlliancePopup';
import MiniResultStatus from '../../common/MiniResultStatus/MiniResultStatus';
import SwitchTabs from '../../common/SwitchTabs/SwitchTabs';
import DataBarsWrapper from '../../common/DataBarsWrapper/DataBarsWrapper';
import DataBar from '../../common/DataBar/DataBar';
import ElectionBattle from '../../common/ElectionBattle/ElectionBattle';
import { createSlug } from '../../../../utils/common';
import CandidateCard from '../../common/CandidateCard/CandidateCard';
import ErrorBoundary from '../../../ErrorBoundary/ErrorBoundary';
import { TOI_LIVE_DOMAIN } from '../../../../constants';

const csValueMapping = {
  3: 'won',
  1: 'leading',
  2: 'trailing',
  4: 'lost',
};

class ResultStateWidget extends React.Component {
  constructor(props) {
    super(props);
    try {
      this.state = {
        activeTab: 1,
      };
      const { powerStates = [] } = this.props;
      this.tabRefs = powerStates.reduce((acc, tab) => {
        acc[tab.key] = React.createRef();
        return acc;
      }, {});
    } catch (error) {
      // Error Occurred
    }
  }

  setActiveTab = tabNum => {
    this.setState({
      activeTab: tabNum?.index ? Number(tabNum?.index) : this.state.activeTab,
    });
  };

  render() {
    const {
      sortedData,
      datasource,
      hideETheading,
      alMasterMap,
      prMasterMap,
      stateName,
      starCandidateData,
      isWapView,
      stateResultPage,
      candidateLinking,
    } = this.props;

    const stateStarCandidateData =
      starCandidateData &&
      Array.isArray(starCandidateData) &&
      starCandidateData.length > 0
        ? starCandidateData.filter(candidate => {
            if (typeof candidate?.star === 'string') {
              const channels = candidate.star.toLowerCase().split(',');
              return channels.includes('tois');
            }
            return false;
          })
        : [];

    const { activeTab } = this.props.activeTab ? this.props : this.state;
    const tabs = [
      { name: 'Alliance View', index: 1 },
      { name: 'Party View', index: 2 },
    ];
    const issource = datasource ? 'withSource' : '';
    return (
      <div className={`${issource} ${!stateResultPage ? s.stateInner : ''}`}>
        {!stateResultPage && (
          <div className={s.switchTabsWrap}>
            <SwitchTabs tabs={tabs} tabHandler={this.setActiveTab} />
          </div>
        )}
        <div
          className={`${s.stateResultWrap} ${
            !stateResultPage ? s.stateResult : ''
          }`}
        >
          <div className="boxStyle">
            <AdCaller
              immediateLoad
              data={{
                jname: 'exit_first',
              }}
            />
            <DataBarsWrapper
              totalSeats={
                sortedData?.states?.[stateName]?.activeSeats ||
                sortedData?.states?.[stateName]?.ttl_seats
              }
              noMinHeight
              countOfLeadPlusWins={{
                winCount: sortedData?.states?.[stateName]?.al_rslt.reduce(
                  (acc, party) => {
                    acc += party.ws;
                    return acc;
                  },
                  0,
                ),
              }}
              infoMsg={sortedData?.states?.[stateName]?.infoMsg}
            >
              {activeTab === 1 &&
                sortedData?.states?.[stateName]?.al_rslt &&
                Array.isArray(sortedData?.states?.[stateName]?.al_rslt) &&
                sortedData?.states?.[stateName]?.al_rslt.length &&
                sortedData?.states?.[stateName]?.al_rslt.map(party => (
                  <DataBar
                    color={
                      activeTab === 1
                        ? alMasterMap?.[party?.an]?.cc ||
                          alMasterMap?.[party?.nm]?.cc
                        : prMasterMap?.[party?.an]?.cc ||
                          prMasterMap?.[party?.nm]?.cc
                    }
                    name={party.an || party.nm}
                    ws={
                      typeof party?.ls === 'number' &&
                      typeof party?.ls === 'number'
                        ? party.ls + party.ws
                        : 0
                    }
                    ttl_seat={
                      sortedData?.states?.[stateName]?.activeSeats ||
                      sortedData?.states?.[stateName]?.ttl_seats
                    }
                  />
                ))}
              {activeTab === 2 &&
                sortedData?.states?.[stateName]?.starpr_rslt &&
                Array.isArray(sortedData?.states?.[stateName]?.starpr_rslt) &&
                sortedData?.states?.[stateName]?.starpr_rslt.length &&
                sortedData?.states?.[stateName]?.starpr_rslt.map(party => (
                  <DataBar
                    color={
                      activeTab === 1
                        ? alMasterMap?.[party?.an]?.cc ||
                          alMasterMap?.[party?.nm]?.cc
                        : prMasterMap?.[party?.an]?.cc ||
                          prMasterMap?.[party?.nm]?.cc
                    }
                    name={party.an || party.nm}
                    ws={
                      typeof party?.ls === 'number' &&
                      typeof party?.ls === 'number'
                        ? party.ls + party.ws
                        : 0
                    }
                    ttl_seat={
                      sortedData?.states?.[stateName]?.activeSeats ||
                      sortedData?.states?.[stateName]?.ttl_seats
                    }
                  />
                ))}
            </DataBarsWrapper>
            <div className={s.miniResultWrap}>
              <Link to={`${TOI_LIVE_DOMAIN}/elections/results`}>
                <>
                  <div className={s.miniResultInfoText}>
                    Lok Sabha Election National Results
                  </div>
                  <MiniResultStatus
                    parties={
                      activeTab === 1
                        ? sortedData?.al_rslt
                        : sortedData?.starpr_rslt
                    }
                    colorMap={activeTab === 1 ? alMasterMap : prMasterMap}
                    isExitPoll={false}
                    noBorder
                    cntCntr
                  />
                </>
              </Link>
            </div>
          </div>
          {stateResultPage &&
            stateName &&
            stateStarCandidateData &&
            Array.isArray(stateStarCandidateData) &&
            stateStarCandidateData.length > 0 && (
              <div className={s.electionBattleWrap}>
                <ElectionBattle
                  isWapView={isWapView}
                  infiniteScroll={false}
                  slidesToShow={4}
                  slidesToScroll={4}
                  adactive
                  candidateLinking={candidateLinking}
                  starCandidateData={starCandidateData.filter(candidates => {
                    if (typeof candidates?.star === 'string') {
                      return (
                        createSlug(stateName) === createSlug(candidates?.sn) &&
                        candidates.star
                          .toLowerCase()
                          .split(',')
                          .includes('tois')
                      );
                    }
                    return false;
                  })}
                  blackArrow
                />
              </div>
            )}
          {!stateResultPage &&
            stateName &&
            stateStarCandidateData && (
              <div className={s.rightCol}>
                <div className={s.title}>Star Candidates</div>
                <div className={s.candidateCardWrap}>
                  {Array.isArray(stateStarCandidateData) &&
                    stateStarCandidateData.length > 0 &&
                    stateStarCandidateData
                      .filter(candidates => {
                        if (typeof candidates?.star === 'string') {
                          return (
                            createSlug(stateName) ===
                              createSlug(candidates?.sn) &&
                            candidates.star
                              .toLowerCase()
                              .split(',')
                              .includes('tois')
                          );
                        }
                        return false;
                      })
                      .map((candidate, idx) => (
                        <ErrorBoundary>
                          <div className={s.candidateBox}>
                            {candidate?.sn &&
                            candidate?.cns_name &&
                            candidate?.seonm &&
                            candidate?.c_id ? (
                              <Link
                                to={`/elections/lok-sabha-elections/${createSlug(
                                  candidate.sn,
                                )}/${createSlug(
                                  candidate.cns_name,
                                )}/candidateshow/${candidate.seonm}-${
                                  candidate.c_id
                                }`}
                                target="_blank"
                              >
                                <CandidateCard
                                  csValueMapping={csValueMapping}
                                  candidate={candidate}
                                  index={idx}
                                  isWapView={isWapView}
                                />
                              </Link>
                            ) : (
                              <CandidateCard
                                csValueMapping={csValueMapping}
                                candidate={candidate}
                                index={idx}
                                isWapView={isWapView}
                              />
                            )}
                          </div>
                        </ErrorBoundary>
                      ))}
                </div>
              </div>
            )}
        </div>
        {datasource && (
          <span className={`${s.sourceText} ${!hideETheading ? s.hide : ''}`}>
            {datasource}
          </span>
        )}
      </div>
    );
  }
}

export default ResultStateWidget;
